module.exports = __webpack_public_path__ + "img/app_icon@2x.65fa3856.png";